import store from '@/store';
import { getInitialStateAutomotor } from './state';

export const updateFormulario = (state, { section, key, value }) => {
   state.formulario[section][key] = value;
};

export const setFormulario = (state, formulario) => {
   state.formulario = { ...state.formulario, ...formulario };
};

export const setVehiculo = (state, vehiculo) => {
   state.formulario.vehiculo = { ...state.formulario.vehiculo, ...vehiculo };
};

export const setAcreedorPrendario = (state, acreedorPrendario) => {
   state.formulario.acreedorPrendario = {
      ...state.formulario.acreedorPrendario,
      ...acreedorPrendario,
   };
};

export const setPago = (state, pago) => {
   state.formulario.pago = { ...state.formulario.pago, ...pago };
};

export const setOpcionesFinanciamiento = (
   state,
   { esPrendaLeasing, esPrendaLeasingEditable },
) => {
   state.formulario.financiamiento.esPrendaLeasing = esPrendaLeasing;
   state.formulario.financiamiento.esPrendaLeasingEditable =
      esPrendaLeasingEditable;
};

export const setCotizaciones = (state, cotizaciones) => {
   state.cotizaciones = cotizaciones.map((cot, index) => ({
      ...cot,
      id: index + 1,
   }));

   if (cotizaciones && cotizaciones.length > 0) {
      const precios = cotizaciones
         .map((cot) => Number(cot.premio) || 0)
         .filter((precio) => precio > 0);

      if (precios.length > 0) {
         const precioMin = Math.min(...precios);
         const precioMax = Math.max(...precios);
         state.filtrosCotizacion.rangoPrecio = [precioMin, precioMax];
      }
   }
};

export const addCotizaciones = (state, nuevasCotizaciones) => {
   const cotizacionesExistentes = Array.isArray(state.cotizaciones)
      ? state.cotizaciones.filter((cot) => cot && cot.idCompania)
      : [];

   const ultimoId =
      cotizacionesExistentes.length > 0
         ? Math.max(...cotizacionesExistentes.map((cot) => cot.id || 0))
         : 0;

   const cotizacionesConId = nuevasCotizaciones.map((cot, index) => ({
      ...cot,
      id: ultimoId + index + 1,
   }));

   state.cotizaciones = [...cotizacionesExistentes, ...cotizacionesConId];

   if (state.cotizaciones && state.cotizaciones.length > 0) {
      const precios = state.cotizaciones
         .map((cot) => Number(cot.premio) || 0)
         .filter((precio) => precio > 0);

      if (precios.length > 0) {
         const precioMin = Math.min(...precios);
         const precioMax = Math.max(...precios);
         state.filtrosCotizacion.rangoPrecio = [precioMin, precioMax];
      }
   }
};

export const setMetadataCotizaciones = (state, metadata) => {
   state.metadataCotizaciones = metadata;
};

export const setLoadingCotizacion = (state, { loading }) => {
   state.loadingCotizaciones = loading;
};

export const resetLoadingCotizaciones = (state) => {
   state.loadingCotizaciones = true;
};

export const toggleSeleccionCotizacion = (state, cotizacionId) => {
   const cotizacion = state.cotizaciones.find((c) => c.id === cotizacionId);
   if (cotizacion) {
      cotizacion.seleccionada = !cotizacion.seleccionada;
   }
};

export const setSeleccionCotizacion = (
   state,
   { cotizacionId, seleccionada },
) => {
   const cotizacion = state.cotizaciones.find((c) => c.id === cotizacionId);
   if (cotizacion) {
      cotizacion.seleccionada = seleccionada;
   }
};

export const limpiarSelecciones = (state) => {
   state.cotizaciones.forEach((cot) => {
      cot.seleccionada = false;
   });
};

export const setMostrarComparacion = (state, mostrar) => {
   state.mostrarComparacion = mostrar;
};

export const setFiltroCotizacion = (state, { key, value }) => {
   if (state.filtrosCotizacion && key in state.filtrosCotizacion) {
      state.filtrosCotizacion = {
         ...state.filtrosCotizacion,
         [key]: value,
      };
   }
};

export const resetFiltrosCotizacion = (state) => {
   state.filtrosCotizacion.busqueda = '';
   state.filtrosCotizacion.ordenar = null;

   const cotizaciones = state.cotizaciones || [];
   const precios = cotizaciones
      .map((cot) => Number(cot.premio) || 0)
      .filter((precio) => precio > 0);

   if (precios.length > 0) {
      const precioMin = Math.min(...precios);
      const precioMax = Math.max(...precios);
      state.filtrosCotizacion.rangoPrecio = [precioMin, precioMax];
   } else {
      state.filtrosCotizacion.rangoPrecio = [20000, 80000];
   }
};

export const setMarcas = (state, marcas) => {
   state.marcaOptions = marcas.map((marca) => ({
      label: marca.name,
      value: marca.id,
   }));
};

export const setModelos = (state, modelos) => {
   state.modeloOptions = modelos.map((modelo) => ({
      label: modelo.descripcion,
      value: modelo.idModelo,
   }));
};

export const setTipoIva = (state, tipoIva) => {
   state.tipoIvaOptions = tipoIva.map((tipoIva) => ({
      label: tipoIva.label,
      value: tipoIva.value,
   }));
};

export const setTipoUso = (state, data) => {
   const { tiposUso, defaultValue } = data;

   state.tipoUsoOptions = tiposUso?.map((tipoUso) => ({
      label: tipoUso.label,
      value: tipoUso.value,
   }));

   const actual = state.formulario?.vehiculo?.tipoUso;
   if (actual === '' || actual === null || actual === undefined) {
      state.formulario.vehiculo.tipoUso = defaultValue;
   }
};

export const setTipoPersona = (state, tipoPersona) => {
   state.tipoPersonaOptions = tipoPersona.map((tipoPersona) => ({
      label: tipoPersona.label,
      value: tipoPersona.value,
   }));
};

export const setActividades = (state, actividades) => {
   state.actividadOptions = actividades;
};

export const setIngresosBrutos = (state, ingresosBrutos) => {
   state.ingresosBrutosOptions = ingresosBrutos;
};

export const setEntidadesFinancieras = (state, entidadesFinancieras) => {
   state.entidadFinancieraOptions = entidadesFinancieras;
};

export const setTipoRastreador = (state, tipoRastreador) => {
   state.rastreadorOptions = tipoRastreador;
};

export const updateVehiculo = (state, { key, value }) => {
   state.formulario.vehiculo[key] = value;
};

export const setEstadoPoliza = (state, estadoPoliza) => {
   state.estadoPoliza = estadoPoliza;
};

export const setCompaniasHabilitadas = (state, companias) => {
   state.companiasHabilitadas = companias;
};

export const setAccesorios = (state, accesorios) => {
   state.accesoriosOptions = accesorios;
};

export const setCanalPagoOptions = (state, canalPagoOptions) => {
   state.canalPagoOptions = canalPagoOptions;
};

export const setFotosRequeridasElNorte = (state, fotos) => {
   state.fotosRequeridasElNorte = Array.isArray(fotos) ? fotos : [];
};

export const addCompaniaNoDisponible = (state, entry) => {
   state.companiasNoDisponibles.push(entry);
};

export const clearCompaniasNoDisponibles = (state) => {
   state.companiasNoDisponibles = [];
};

export const resetState = (state) => {
   const idEmpresa = store.state.auth?.usuario?.id_empresa;
   const idGrupo = store.state.auth?.usuario?.id_grupo;
   Object.assign(state, getInitialStateAutomotor(idEmpresa, idGrupo));
};
